import { Box, Grid, Typography, Breadcrumbs, useMediaQuery, useTheme } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import CustomSearchInput from '../common/CustomSearchInput'
import { useNavigate} from 'react-router-dom';
import { HttpRequest } from '../HttpRequest';
import { Delete,RemoveCircleOutlineOutlined } from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";



const CustomerAdminComponent = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const [search, setSearch] = useState('')
  const [customersState, setCustomersState] = useState({ isLoading: false, data: [], returningColumns: [], total: 0, page: 1, pageSize: 10 });
  const navigate = useNavigate();

  const handleRowClick = (event, params) => {
    event.stopPropagation();
    navigate(`/zed_ecommerce/customer/${params?.row?._id}/details`);
  }

  const columns = [
    {
      field: 'name', headerName: 'Name', flex: isMobile ? 1.5 : 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}>Name  </Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event)=>handleRowClick(event,params)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "550", display: 'flex', alignItems: 'center', height: '100%' }}>
          <Grid container spacing={2} sx={{ display: 'flex' }}>
            <Grid item>
              <Typography sx={{ marginTop: '0 42px 0 0',fontFamily:'Poppins',fontSize: isMobile ? "11px" : "14px",fontWeight:550,textAlign:'left',color:'#000',textDecoration:'underline' }}>{params?.row?.customerName}</Typography>
            </Grid>
          </Grid>
        </Box>)
      }
    },
    {
      field: 'email', headerName: 'Email', flex: isMobile ? 1.5 : 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Email  </Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event)=>handleRowClick(event,params)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500", display: 'flex', alignItems: 'center', height: '100%' }}>
          {params?.row?.email}
        </Box>)
      }
    },
    {
      field: 'phone', headerName: 'Phone No.', flex: isMobile ? 1 : 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Phone No.</Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event)=>handleRowClick(event,params)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500", display: 'flex', alignItems: 'center', height: '100%' }}>
          {params?.row?.phone}
        </Box>)
      }
    },
    {
      field: 'location', headerName: 'location', flex: isMobile ? 1.2 : 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Location </Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event)=>handleRowClick(event,params)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500", display: 'flex', alignItems: 'center', height: '100%' }}>
          {params?.row?.physicalAddress}
        </Box>)
      }
    },
    {
      field: 'orders', headerName: 'Orders', flex: isMobile ? 0.8 : 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Orders  </Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event)=>handleRowClick(event,params)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500", display: 'flex', alignItems: 'center', height: '100%' }}>
          {params?.row?.noOfOrders} Orders
        </Box>)
      }
    },
    {
      field: 'amountSpent', headerName: 'Amount Spent', flex: isMobile ? 1 : 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Amount Spent  </Box>) },
      renderCell: (params) => { return (<Box onClick={(event)=>handleRowClick(event,params)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500", display: 'flex', alignItems: 'center', height: '100%' }}> Ksh {params?.row?.totalAmountOfOrders} </Box>) }
    },
    {
      field: 'actions', headerName: 'Actions', flex: isMobile ? 0.8 : 1,
      renderHeader: (params) => {
        return (
          <Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}>Actions </Box>)
      },
      renderCell: (params) => {
        return (
          <Box onClick={(event)=>handleRowClick(event,params)} style={{ color: "#032541", fontSize: isMobile ? "14px" : "17px", fontWeight: "700", display: 'flex' }}>
            <RemoveCircleOutlineOutlined sx={{ color: '#000000', margin: '0 12px 0 0', cursor: 'pointer', fontSize: isMobile ? "18px" : "25px" }} />
            <Delete sx={{ color: '#DC3545', cursor: 'pointer', fontSize: isMobile ? "18px" : "25px" }} />
          </Box>)
      },
    }
  ]
  const getCustomers = useCallback(() => {
    setCustomersState((old) => ({ ...old, isLoading: true }));
    
    HttpRequest({
      method: 'GET',
      url: `/api/v1/ecommerce/getzedecommercecustomers?page=${customersState?.page}&limit=${customersState?.pageSize}&searchValue=${search}`,
    })
      .then((data) => {
        setCustomersState((old) => ({
          ...old,
          data: data?.response?.data,
          total: data?.response?.count,
          isLoading: false,
        }));
      })
      .catch(() => {
        setCustomersState((old) => ({ ...old, isLoading: false }));
      });
  }, [customersState?.page, customersState?.pageSize, search]);
  
  useEffect(() => {
    getCustomers();
  }, [customersState?.page,customersState?.pageSize,search,getCustomers]);

  const breadcrumbs = [
        <Typography key="X" sx={{ color: "#707070", fontSize: "0.875rem", ml: isMobile ? 0 : 3 }}>
            Dashboard
        </Typography>,
        <Typography key={"add"} sx={{ color: "#dc3545", fontSize: "0.875rem" }}>
          Customers
        </Typography>
    ];
  return (
      <Box sx={{ mt: { xs: "15%", sm: "4%" }, pr: { xs: 2, sm: "3.5%" }, width: { xs: "100vw", sm: "calc(100vw - 380px)" }, maxWidth: "100%", overflowX: "hidden", boxSizing: "border-box", px: { xs: 2, sm: 0 }, ml: { xs: -3, sm: 0 } }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: { xs: "flex-start", sm: "center" }, flexDirection: { xs: "column", sm: "row" }, gap: { xs: 2, sm: 0 } }}>
          <Box sx={{ flexDirection: "column", flex: 1 }}>
            <Box mb={1.5}>
              <Typography variant='h4' sx={{ color: "#032541", fontSize: { xs: "18px", sm: "28px" }, fontStyle: "normal", fontWeight: "600" }}>Customers</Typography>
            </Box>
            <Grid item sx={{ mt: 1, mb: { xs: 1, sm: 1 }, ml: { xs: 0, sm: -3 } }}>
              <Breadcrumbs style={{ fontFamily: 'Poppins', fontSize: { xs: "11px", sm: "13px" } }} separator={<FiberManualRecordIcon style={{ fontSize: "0.625rem", fontFamily: 'Poppins', color: "#e1e5e8" }} />} aria-label="breadcrumb">
                  {breadcrumbs}
              </Breadcrumbs>
            </Grid>
            <Box ml={0.5}>
              <Typography variant='h4' sx={{ color: "#707070", fontSize: { xs: "12px", sm: "14px" }, fontStyle: "normal", fontWeight: "normal" }}>View and manage your Customers.</Typography>
            </Box>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', mt: 2 }}>
          <Box sx={{ width: { xs: '100%', sm: 'auto' } }}>
            <CustomSearchInput placeholder={"Search ...."} name="search" value={search} onChange={(event)=>setSearch(event.target.value)} sx={{ width: { xs: '100%', sm: 'auto' } }} />
          </Box>
        </Box>
        <Box sx={{ width: '100%', overflowX: 'auto', mt: 2 }}>
          <Box sx={{ minWidth: { xs: 800, sm: '100%' } }}>
        <DataGrid
              sx={{ minHeight: '400px', height: 'auto', width: 'auto', fontFamily: 'Poppins', fontSize: isMobile ? '10px' : '12px', color: '#272d3d', boxShadow: 0, border: 0, '& .MuiDataGrid-cell': { display: 'flex', alignItems: 'center', fontSize: isMobile ? '10px' : '12px' } }}
                rowCount={customersState?.total}
                pagination
                loading={customersState?.isLoading}
                page={customersState?.page - 1}
                pageSizeOptions={[1, 10, 20, 50, 100]}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: customersState?.pageSize,
                      page: customersState?.page - 1,
                    },
                  },
                }}
                pageSize={customersState?.pageSize}
                onPaginationModelChange={(data) => {
                  const { pageSize, page } = data;
                  setCustomersState((old) => ({ ...old, page: page + 1, pageSize: pageSize }));
                }}
                paginationMode="server"
                columns={columns}
                rows={customersState?.data}
                getRowId={(row) => row._id}
              
              />
          </Box>
        </Box>
      </Box>
  )
}

export default CustomerAdminComponent